/* hb-speed P0-5: upgrade the static+CSS Selling Fast badge to the 18 KB VP9-alpha WebM on engines with reliable
   VP9 alpha (Chromium, Firefox). Safari/iOS (all iOS browsers are WebKit) keep the CSS-animated WebP.
   The <img> is only replaced once the video is actually playing; on any failure the CSS badge simply stays. */
(function () {
  if (window.__hbSfBadge) return;
  window.__hbSfBadge = true;
  var ua = navigator.userAgent;
  var webkitOnly = /iPhone|iPad|iPod|CriOS|FxiOS|EdgiOS/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ||
    (/Safari\//.test(ua) && !/(Chrome|Chromium|Edg|OPR|Firefox)\//.test(ua));
  if (webkitOnly) return;
  if (navigator.connection && navigator.connection.saveData) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var probe = document.createElement('video');
  if (!probe.canPlayType || !probe.canPlayType('video/webm; codecs="vp9"')) return;

  function upgrade(img) {
    if (img.dataset.hbSfDone) return;
    img.dataset.hbSfDone = '1';
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true; v.preload = 'auto';
    ['muted', 'playsinline', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { v.setAttribute(a, ''); });
    v.setAttribute('role', 'img');
    v.setAttribute('aria-label', img.alt);
    v.setAttribute('width', img.getAttribute('width'));
    v.setAttribute('height', img.getAttribute('height'));
    v.className = img.className;
    v.style.visibility = 'hidden';
    var done = false;
    function fail() { if (done) return; done = true; v.removeAttribute('src'); v.load(); if (v.parentNode) v.parentNode.removeChild(v); }
    v.addEventListener('playing', function () {
      if (done) return; done = true;
      v.style.visibility = '';
      if (img.parentNode) img.parentNode.removeChild(img);
      if (visIO) visIO.observe(v);
    }, { once: true });
    v.addEventListener('error', fail, { once: true });
    setTimeout(fail, 5000);
    v.src = img.dataset.hbSfWebm;
    img.insertAdjacentElement('afterend', v);
    var p = v.play();
    if (p && p.catch) p.catch(fail);
  }
  // pause badge videos while off-screen (no VP9 decoding for badges nobody can see)
  var visIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } else { e.target.pause(); }
    });
  }) : null;
  function run() {
    var imgs = document.querySelectorAll('img.hb-sf-badge[data-hb-sf-webm]');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(upgrade); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); upgrade(e.target); } });
    }, { rootMargin: '200px 0px' });
    imgs.forEach(function (i) { io.observe(i); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
